import React, { Component } from 'react';
import SimpleLayout from './SimpleLayout';
import PublicEventEditDetail from '../components/pubevent/PublicEventEditDetail';
import { translate } from "react-i18next";
import '../css/style.css';
import '../components/Home.css';

class PublicEventCloneLayout extends Component {

    constructor(props) {
        super(props);
    
    
        this.state = {
            eventDetail:{}
        };
      }

    render(){
        const { t } = this.props;
        const { params } = this.props.match
         return (<SimpleLayout title={t("publicEventEdit")}  eventKey="2">
               <PublicEventEditDetail eventId= {params.id} />
           </SimpleLayout>)
       }

}

export default translate("translations")(PublicEventCloneLayout);